jQuery(document).ready(function () {
    'use strict';

    const skipBtn = document.getElementById('skip');
    const startBtn = document.getElementById('splashNext');

    if(startBtn) {
        startBtn.addEventListener("click", function (){
            const cookieName = "onBoarding";
            const cookieValue = "Cookie";
            const cookieExpireDays = 30;

            let currentDate = new Date();
            currentDate.setTime(
                currentDate.getTime() + cookieExpireDays * 24 * 60 * 60 * 1000
            );

            let expires = "expires=" + currentDate.toGMTString();

            document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
        });
    }

    if(skipBtn) {
        skipBtn.addEventListener("click", function (){
            const cookieName = "onBoarding";
            const cookieValue = "Cookie";
            const cookieExpireDays = 30;

            let currentDate = new Date();
            currentDate.setTime(
                currentDate.getTime() + cookieExpireDays * 24 * 60 * 60 * 1000
            );

            let expires = "expires=" + currentDate.toGMTString();

            document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
        });
    }
});
